import {
    applyMiddleware,
    combineReducers,
    compose,
    createStore,
    Reducer,
} from 'redux'
import thunk from 'redux-thunk'
import userReducer from './reducers/user'
import loadingReducer from './reducers/loading'
import successReducer from './reducers/success'
import errorsReducer from './reducers/errors'
import messageReducer from './reducers/message'
import permissionsReducer from './reducers/permissions'
import layoutReducer from './reducers/layout'
import filtersReducer from './reducers/filters'
import commentsReducer from './reducers/comments'
import { composeWithDevTools, EnhancerOptions } from 'redux-devtools-extension'
import { UserActionTypes } from '../Techedge-digitalportal-shared'

export const sharedReducers = {
    userReducer,
    loadingReducer,
    successReducer,
    errorsReducer,
    messageReducer,
    permissionsReducer,
    layoutReducer,
    filtersReducer,
    commentsReducer,
}

const composeEnhancers = composeWithDevTools

// Configure the store
export default () => {
    const store = createStore(
        createReducer(),
        composeEnhancers(applyMiddleware(thunk))
    )

    // Add a dictionary to keep track of the registered async reducers
    // @ts-ignore
    store.asyncReducers = {}

    // Create an inject reducer function
    // This function adds the async reducer, and creates a new combined reducer
    // @ts-ignore
    store.injectReducer = (key: string, asyncReducer: Reducer) => {
        // @ts-ignore
        store.asyncReducers[key] = asyncReducer
        // @ts-ignore
        store.replaceReducer(createReducer(store.asyncReducers))
    }

    // Return the modified store
    return store
}

function createReducer(asyncReducers: Record<string, Reducer> = {}) {
    return (state: any, action: any) => {
        if (action.type === UserActionTypes.USER_LOGOUT) {
            state = undefined
        }
        let newState = state
        if (!!state) {
            newState = {
                ...state,
                successReducer: {
                    ...(state?.successReducer || {}),
                    toastList: [],
                },
            }
        }
        return combineReducers({
            ...sharedReducers,
            ...asyncReducers,
        })(newState, action)
    }
}
